import { RecordVisibility } from "../enum/recordVisibility.enum";
import { SelectOption } from "../types/SelectOption";

export const recordVisibility: SelectOption[] = [
    { label: "Private (only for me)", id: RecordVisibility.private },
    { label: "Public", id: RecordVisibility.public },
  ];